(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FreightPaymentController', FreightPaymentController);

    FreightPaymentController.$inject = ['$scope', '$state', 'FreightPayment', '$uibModal', 'ToastrService', 'FreightPaymentCustomService', 'FreightPaymentGridDTO', 'SingleDblClickService'];

    function FreightPaymentController($scope, $state, FreightPayment, $uibModal, ToastrService, FreightPaymentCustomService, FreightPaymentGridDTO, SingleDblClickService) {
        var vm = this;

        vm.fps = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.loadAll = loadAll;

        vm.addFreightPayment = addFreightPayment;
        vm.createShipment = createShipment;
        vm.assignToShipment = assignToShipment;

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.paymentDateFrom = {
            opened: false
        };
        $scope.paymentDateTo = {
            opened: false
        };
        $scope.openPaymentDateFrom = function () {
            $scope.paymentDateFrom.opened = true;
        };
        $scope.openPaymentDateTo = function () {
            $scope.paymentDateTo.opened = true;
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.paymentDateFrom = false;
        vm.datePickerOpenStatus.paymentDateTo = false;

        vm.gridOptions = {
            paginationPageSizes: [10,25,50,75,100],
            paginationPageSize: 100,
            enableRowSelection: true,
            enableSelectAll: false,
            enableFiltering: false,
            enableGridMenu: true,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function(gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                    vm.page = newPage -1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                    if(sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = sortColumns[0].field;
                        vm.revers = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {name: 'BL #', field: 'blNumber', visible: true},
                {name: 'Booking #', field: 'shipmentBookingNumber', visible: true},
                {name: 'Carrier', field: 'carrier', visible: true},
                {name: 'Payment Date', field: 'paymentDate', visible: true},
                {name: 'Invoice Amount', field: 'invoiceAmountDisplay', visible: true},
                {name: 'Shipment', field: 'shipment', visible: true},
                {name: 'Comment', field: 'comment', visible: true}
            ]
        };

        vm.shipments = [];

        initFilter();
        loadAll();

        function initFilter() {
            vm.filterModel = {
                paymentDateFrom: '',
                paymentDateTo: '',
                shipmentBookingNumber: '',
                blNumber: '',
                carrier: '',
                shipment: '',
                invoiceAmountFrom: '',
                invoiceAmountTo: ''
            }
        }

        function loadAll() {
            if(vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.fps = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            queryParams = Object.assign({}, queryParams, vm.filterModel);
            FreightPaymentGridDTO.query(queryParams, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc':'desc')];
                if(vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.fps = angular.copy(data);
                vm.gridOptions.data = vm.fps;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                $scope.gridApi.selection.clearSelectedRows();
                ToastrService.success("Successfully fetched Freight Payments", "Success!");
            }

            function onError(error) {
                ToastrService.error("Failed to fetch Freight Payments", "Error");
            }
        }

        function reset() {
            vm.page = 0;
            vm.fps = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function addFreightPayment() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/freight-payment/freight-payment-dialog.html',
                controller: 'FreightPaymentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function(){
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            paymentDate: null,
                            invoiceAmount: 0,
                            invoiceCurrency: 'USD',
                            invoiceAmountDisplay: null,
                            shipmentBookingNumber: null,
                            blNumber: null,
                            carrier: null
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                reset();
            });
        }

        function createShipment() {
            var selectedFreightPayment = $scope.gridApi.selection.getSelectedRows()[0];
            var route = 'shipment.new';
            var data = {
                heading: 'New Shipment',
                route: route,
                id: selectedFreightPayment.id,
                param: {
                    fpId: selectedFreightPayment.id
                }
            };
            vm.createTab(data);
        }

        function assignToShipment() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/freight-payment/modal/freight-payment-assign-to-shipment.html',
                controller: 'FreightPaymentAssignToShipmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return FreightPayment.get({id:$scope.gridApi.selection.getSelectedRows()[0].id}).$promise;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                reset();
            });
        }

        $scope.rowSingleClick = function(row) {
            SingleDblClickService.singleClick(row, 'freight-payment.detail', 'fp');
        };

        $scope.rowDblClick = function(row) {
            SingleDblClickService.dblClickModal(row, 'fp').result.then(function() {
                reset();
            });
        };

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        };

        vm.cleanFilter = function() {
            initFilter();
            reset();
        }
    }
})();
